import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

let defaultLangStr = navigator.language;
let defaultPath = "/en/";

if (defaultLangStr.indexOf("zh") >= 0) {
  defaultPath = "/zh/";
}

const routes = [
  {
    path: "/",
    redirect: {
      path: defaultPath,
    },
  },
  {
    path: "/zh/",
    name: "zh/Home",
    meta: {
      title: "Transit Swap",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/zh/Home.vue"),
  },
  {
    path: "/en/",
    name: "en/Home",
    meta: {
      title: "Transit Swap",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/en/Home.vue"),
  },
  {
    path: "/zh/donation",
    name: "zh/Donation",
    meta: {
      title: "Transit Swap",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/zh/Donation.vue"),
  },
  {
    path: "/en/donation",
    name: "en/Donation",
    meta: {
      title: "Transit Swap",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/en/Donation.vue"),
  },
  {
    path: "/zh/stake",
    name: "zh/Stake",
    meta: {
      title: "Transit Swap",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/zh/Stake.vue"),
  },
  {
    path: "/en/stake",
    name: "en/Stake",
    meta: {
      title: "Transit Swap",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/en/Stake.vue"),
  },
  {
    path: "/zh/fee",
    name: "zh/Fee",
    meta: {
      title: "Transit Swap",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/zh/Fee.vue"),
  },
  {
    path: "/en/fee",
    name: "en/Fee",
    meta: {
      title: "Transit Swap",
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/en/Fee.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
